var _a;
import { createSlice } from '@reduxjs/toolkit';
var authSlice = createSlice({
    name: 'auth',
    initialState: {
        loggedIn: false,
        chatMachineToken: null,
        mapboxAccessToken: null,
        speechKey: null,
        translationKey: null,
        visionKey: null
    },
    reducers: {
        setCurrentUser: function (state, action) {
            state.currentUser = action.payload;
            state.loggedIn = true;
        },
        setChatMachineToken: function (state, action) {
            state.chatMachineToken = action.payload;
        },
        setSpeechKey: function (state, action) {
            state.speechKey = action.payload;
        },
        setTranslationKey: function (state, action) {
            state.translationKey = action.payload;
        },
        setVisionKey: function (state, action) {
            state.visionKey = action.payload;
        },
        setMapboxAccessToken: function (state, action) {
            state.mapboxAccessToken = action.payload;
        }
    }
});
export default authSlice.reducer;
export var setCurrentUser = (_a = authSlice.actions, _a.setCurrentUser), setChatMachineToken = _a.setChatMachineToken, setSpeechKey = _a.setSpeechKey, setTranslationKey = _a.setTranslationKey, setVisionKey = _a.setVisionKey, setMapboxAccessToken = _a.setMapboxAccessToken;
export var auth = function (state) { return state.auth; };
